module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/bodyOil_603902.png";